import React from "react";
import { useFormBuilderType } from "hooks";
import AdvancedBuilder from "containers/Form/AdvancedBuilder";
import SimplifiedBuilder from "containers/Form/SimplifiedBuilder";

const Builder = ({
	...rest
}) => {
	const isSimple = useFormBuilderType() === "simple";

	const BuilderView = isSimple
		? SimplifiedBuilder
		: AdvancedBuilder;

	return <BuilderView {...rest} />;
};

export default Builder;